/* global axios */
import ApiClient from './ApiClient';

class AgentPauseSessionsAPI extends ApiClient {
  constructor() {
    super('agent_pause_sessions', { accountScoped: true });
  }

  start(pauseTypeId) {
    return axios.post(this.url, { pause_type_id: pauseTypeId });
  }

  end() {
    return axios.delete(`${this.url}/end`);
  }

  getPauseReport(accountId, params) {
    return axios.get(
      `/api/v1/accounts/${accountId}/reports/agent_pauses`,
      { params }
    );
  }
}

export default new AgentPauseSessionsAPI();
